import React from 'react';

export default function NotEmpty({ data, placeholder = 'Nenhum registro.', children }) {
  let check = data;

  if (data && typeof data === 'object') {
    check = Object.values(data);
  }

  if (!check?.length) {
    return placeholder;
  }

  return <>{children}</>;
}
